import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledSend = styled.svg<IconProps>`
  & .cls-1 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &.disabled {
    .cls-2 {
      fill: var(--du-color-grey, #969696);
      stroke: var(--du-color-grey, #969696);
    }
  }

  &: hover, &.active {
    &:not([disabled]) {
      .cls-2 {
        fill: var(--du-color-primary, #128370);
      }
    }
  }
`;

const SendIcon: React.FC<IconProps> = ({ active, disabled }) => {
  const activeclass = disabled ? 'disabled' : active ? 'active' : undefined;
  return (
    <StyledSend
      id='Settings-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
      disabled={disabled}
    >
      <rect id='Rectangle_677' data-name='Rectangle 677' className='cls-1' width='32' height='32' />
      <path
        id='Subtraction_1'
        data-name='Subtraction 1'
        className='cls-2'
        d='M-1989.693,16V12l8.532-4-8.531-4V0l16,8-16,8Z'
        transform='translate(1998.692 8)'
      />
    </StyledSend>
  );
};

export default SendIcon;
